import { Result } from "nutso";
import * as React from "react";
import { FormMeta } from "./FormMeta";
// TODO:SCSS import "../scss/widgets/auth_widget.scss"

export type FormItemProps<T> = {
  label: string;
  helpText?: string;
  additionalClassNames?: string;
  validation?: Result<T>; // passed to form meta
};

export const FormItemContainer = <T,>(props: FormItemProps<T> & { children: React.ReactNode }) => {
  const { label, additionalClassNames } = props;
  return (
    <div className={`form-item ${additionalClassNames}`}>
      {label && <label className="label">{label}</label>}
      <div className={`form-input`}>{props.children}</div>
      <FormMeta {...props} />
    </div>
  );
};